module.exports = __webpack_public_path__ + "img/4.013ea70f.jpg";